import React from "react"
import Seo from "../components/seo"
import Layout from "../components/layout"
import { Link } from 'gatsby'
import NoteLists from "../components/note/note-lists"
import ArticleArea from "../components/note/article-area"
import MagazineSlide from "../components/note/magazine-slide"
import "../styles/pc/page/note.scss"
import "../styles/sp/page/note.scss"

export default function NotePage() {
  return (
    <Layout isNote={true}>
      <Seo
        type="article"
        title="ジェイフィールのオウンドメディア 一覧"
        description="ジェイフィールの探求をお届けするオウンドメディア、J.Feel Noteです。様々な活動を通して学んだ知見、生まれてきた想いなどを皆さんに共有します。一緒に考えを深めていきましょう。"
        bobyClassName="menu25"
        path="note"
      />
      <div className="wrapper">
        {/*//////////////////////////////* ↓マガジンスライド * //////////////////////////////*/}

        <MagazineSlide />

        {/*//////////////////////////////* ↑マガジンスライド * //////////////////////////////*/}

        <div className="wrapper_contents">
          <div className="path fixed pc_only">
            <div className="left_navi"><span className="vertical"><Link to="/">Home</Link>　/　<Link to="/note" className="current">J.Feel Note</Link></span></div>
          </div>
          <div className="main">
        {/*//////////////////////////////* ↓コンテンツ01 * //////////////////////////////*/}

        <NoteLists />

        {/*//////////////////////////////* ↑コンテンツ01 * //////////////////////////////*/}
          </div>{/* main */}
          <div className="page_title fixed">
            <div className="right_page_ttl"><span className="vertical">J.Feel Note - </span><span className="txt">ジェイフィールのオウンドメディア</span></div>
          </div>{/* right page_title */}
        </div>{/*wrapper_contents*/}
      </div>{/*wrapper*/}

    </Layout>
  )
}